<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: zouyuping
 * @LastEditTime: 
 * @FilePath: 
 * @Description: 空白vue模板
-->
<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "Test1",
  props: {

  },
  data() {
    return {

    };
  },
  components: {

  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
